import { createAsyncThunk } from '@reduxjs/toolkit';

import { getTerritories } from '@/api/places';

export const fetchTerritories = createAsyncThunk(
  'territories/fetch-countries',
  getTerritories,
);
